import { render, staticRenderFns } from "./RealNameDialog.vue?vue&type=template&id=54ce648d&scoped=true&"
import script from "./RealNameDialog.vue?vue&type=script&lang=js&"
export * from "./RealNameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce648d",
  null
  
)

export default component.exports